// skipcq: JS-W1028, JS-0128
import React, { useCallback, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import DashboardLayout from '../../components/layout/DashboardLayout';
import TabPanel from '../../components/tabs/TabPanel';
import CreateScheduleDialog from './CreateScheduleDialog';
import OverviewTab from './OverviewTab';
import SchedulesTab from './SchedulesTab';
import CrawlExecutionsTab from './CrawlExecutionsTab';
import DispatcherTab from './DispatcherTab';
import PlanningTab from './PlanningTab';

function CrawlerSchedulerPage() {
  const [tab, setTab] = useState(0);
  const [createOpen, setCreateOpen] = useState(false);

  const handleTabChange = useCallback((event, newValue) => {
    setTab(newValue);
  }, []);

  const handleOpenCreate = useCallback(() => {
    setCreateOpen(true);
  }, []);

  const handleCloseCreate = useCallback(() => {
    setCreateOpen(false);
  }, []);

  return (
    <DashboardLayout title="Crawler scheduler">
      <Container maxWidth={false} sx={{ mt: 2, mb: 4, px: { xs: 2, sm: 3 } }}>
        <Typography variant="body1" color="text.secondary" paragraph>
          Operate crawler schedules — SLO snapshot, deterministic planning, dispatcher history, executions, pauses,
          replans, and on-demand runs.
        </Typography>
        <Box display="flex" flexWrap="wrap" justifyContent="flex-end" gap={2} sx={{ mb: 2 }}>
          <Button variant="contained" onClick={handleOpenCreate}>
            Create schedule
          </Button>
        </Box>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            mb: 2,
          }}
        >
          <Tabs value={tab} onChange={handleTabChange} aria-label="Crawler scheduler tabs">
            <Tab label="Overview" id="scheduler-tab-0" aria-controls="scheduler-panel-0" />
            <Tab label="Planning" id="scheduler-tab-1" aria-controls="scheduler-panel-1" />
            <Tab label="Schedules" id="scheduler-tab-2" aria-controls="scheduler-panel-2" />
            <Tab label="Dispatcher" id="scheduler-tab-3" aria-controls="scheduler-panel-3" />
            <Tab label="Executions" id="scheduler-tab-4" aria-controls="scheduler-panel-4" />
          </Tabs>
        </Box>
        <TabPanel value={tab} index={0} disableGutters>
          <OverviewTab />
        </TabPanel>
        <TabPanel value={tab} index={1} disableGutters>
          <PlanningTab />
        </TabPanel>
        <TabPanel value={tab} index={2} disableGutters>
          <SchedulesTab />
        </TabPanel>
        <TabPanel value={tab} index={3} disableGutters>
          <DispatcherTab />
        </TabPanel>
        <TabPanel value={tab} index={4} disableGutters>
          <CrawlExecutionsTab />
        </TabPanel>
      </Container>
      <CreateScheduleDialog open={createOpen} onClose={handleCloseCreate} />
    </DashboardLayout>
  );
}

export default CrawlerSchedulerPage;
